import { render, staticRenderFns } from "./RedirectToDevice.vue?vue&type=template&id=1be410bd&scoped=true&"
import script from "./RedirectToDevice.vue?vue&type=script&lang=js&"
export * from "./RedirectToDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be410bd",
  null
  
)

export default component.exports